import Home from "../views/Home.vue";
import MyCourses from "../views/MyCourses.vue";
import Profile from "../views/Profile.vue";
import Courses from "../views/Courses.vue";
import Course from "../views/Course.vue";
import Lecture from "../views/Lecture.vue";
import Exams from "../views/Exams.vue";
import MyExams from "../views/MyExams/MyExams.vue";
import MyHomeworks from "../views/MyExams/MyHomeworks.vue";
import WrongAnswers from "../views/MyExams/WrongAnswers.vue";
import Teachers from "../views/Teachers.vue";
import Teacher from "../views/Teacher.vue";
import SubjectTeachers from "../views/SubjectTeachers.vue";
import Exam from "../views/Exam.vue";
import Wallet from "../views/Wallet/index.vue";
import CenterWallet from "../views/CenterWallet/index.vue";
import Welcome from "../views/Welcome.vue";
import Support from "../views/Support.vue";
import Attachments from "../views/Attachments.vue";
import MyQuestions from "../views/BankQuestions/MyQuestions.vue";
import BankQuestions from "../views/BankQuestions/index.vue";
const routes = [
    {
        path: '/',
        name: 'welcome',
        component: Welcome,
        meta :{
            requiresAuth: false,
            requiresGuest: true,
            landingFullScreen: true,
            footer: {
                show: false,
            },
            whiteBackground: true,
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta :{
            title: 'الصفحة الرئيسية',
            requiresAuth: true
        }
    },
    {
        path: '/honor-board',
        name: 'honor-board',
        component: () => import('../views/HonorBoard.vue'),
        meta: {
            title: 'لوحة الشرف',
            requiresAuth: true,
            backButton: true,
            // Hidden until API returns more students + exam finish times
            hideFromNav: true,
        },
        // Keep route code ready, but block public access for now
        beforeEnter(to, from, next) {
            next({ name: 'home' });
        },
    },
    {
        path: '/honor-panel',
        name: 'honor-panel',
        component: () => import('../views/HonorPanel.vue'),
        meta: {
            title: 'لوحة الشرف',
            requiresAuth: true,
        },
    },
    {
        path: '/courses',
        name: 'courses',
        component: Courses,
        meta :{
            title: 'الدورات التعليمية',
            // requiresAuth: true
        }
    },
    {
        path: '/grade-10',
        name: 'grade-10',
        component: () => import('../views/Grade10.vue'),
        meta: {
            title: 'أولى ثانوي Programming & AI',
            requiresAuth: false,
            requiresGuest: false,
            gradeSlug: 'grade-10',
            landingFullScreen: true,
            footer: { show: false },
            whiteBackground: true,
        },
    },
    {
        path: '/grade-11',
        name: 'grade-11',
        component: () => import('../views/Grade11.vue'),
        meta: {
            title: 'تانية ثانوي Programming & AI',
            requiresAuth: false,
            requiresGuest: false,
            gradeSlug: 'grade-11',
            landingFullScreen: true,
            footer: { show: false },
            whiteBackground: true,
        },
    },
    {
        path: '/grade-10-programming-ai-curriculum',
        name: 'grade-10-programming-ai-curriculum',
        component: () => import('../views/Grade10Curriculum.vue'),
        meta: {
            title: 'منهج البرمجة أولى ثانوي',
            requiresAuth: false,
            requiresGuest: false,
            landingFullScreen: true,
            footer: { show: false },
            whiteBackground: true,
        },
    },
    {
        path: '/grade-11-programming-ai-curriculum',
        name: 'grade-11-programming-ai-curriculum',
        component: () => import('../views/Grade11Curriculum.vue'),
        meta: {
            title: 'منهج البرمجة تانية ثانوي بكالوريا | كتاب الوزارة',
            requiresAuth: false,
            requiresGuest: false,
            landingFullScreen: true,
            footer: { show: false },
            whiteBackground: true,
        },
    },
    {
        path: '/essay-questions',
        name: 'essay-questions',
        component: () => import('../views/EssayQuestions.vue'),
        meta: {
            title: 'حل أسئلة المقالي',
            requiresAuth: false,
            requiresGuest: false,
            landingFullScreen: true,
            footer: { show: false },
            whiteBackground: true,
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta :{
            title: 'الملف الشخصي',
            requiresAuth: true
            // whiteBackground: true,
        }
    },
    {
        path: '/my-courses',
        name: 'my-courses',
        component: MyCourses,
        meta :{
            title: 'دوراتي',
            requiresAuth: true
            // whiteBackground: true,
        }
    },
    {
        path: '/attachments',
        name: 'attachments',
        component: Attachments,
        meta :{
            title: 'مذكرات',
            whiteBackground: true,
        }
    },
    {
        path: '/courses/:id',
        name: 'course',
        component: Course,
        meta :{
            title: 'صفحة الدورة',
            backButton: true,
            // requiresAuth: true
            // temporaryMenu: true,
        }
    },
    {
        path: '/lectures/:id',
        name: 'lecture',
        component: Lecture,
        meta :{
            title: 'المحاضرة',
            backButton: true,
            requiresAuth: true
            // temporaryMenu: true,
        }
    },
    {
        path: '/teachers',
        name: 'teachers',
        component: Teachers,
        meta :{
            title: 'المعلمين',
            requiresAuth: true,
        }
    },
    {
        path: '/teachers/:id',
        name: 'teacher',
        component: Teacher,
        meta :{
            title: 'دورات المعلم',
        }
    },
    {
        path: '/subjects/:id',
        name: 'subject-teachers',
        component: SubjectTeachers,
        meta :{
            title: 'معلمو المادة',
            requiresAuth: true,
            backButton: true,
        }
    },
    {
        path: '/my-exams/exams',
        name: 'my-exams',
        component: MyExams,
        meta :{
            title: 'نتائج امتحاناتي',
            requiresAuth: true,
        }
    },
    {
        path: '/my-exams/homeworks',
        name: 'my-homeworks',
        component: MyHomeworks,
        meta :{
            title: 'نتائج واجباتي',
            requiresAuth: true,
        }
    },
    {
        path: '/my-exams/wrong-answers',
        name: 'wrong-answers',
        component: WrongAnswers,
        meta :{
            title: 'الأسئلة الخاطئة',
            requiresAuth: true,
        }
    },
    {
        path: '/exams',
        name: 'exams',
        component: Exams,
        props: true,
        meta :{
            title: 'الامتحان اﻹلكتروني',
            requiresAuth: true,
            temporaryMenu: true
        }
    },
    {
        path: '/exams/session',
        name: 'exam-session',
        component: Exam,
        props: true,
        meta :{
            title: 'الامتحان اﻹلكتروني',
            requiresAuth: true,
            temporaryMenu: true
        }
    },
    {
        path: '/wallet',
        name: 'wallet',
        component: Wallet,
        meta :{
            title: 'المحفظة الإلكترونية',
            requiresAuth: true
        }
    },
    {
        path: '/center-wallet',
        name: 'center-wallet',
        component: CenterWallet,
        meta :{
            title: 'مدفوعات السنتر',
            requiresAuth: true
        }
    },
    {
        path: '/questions-bank/my-questions',
        name: 'my-questions',
        component: MyQuestions,
        meta :{
            title: 'أسئلتي',
            requiresAuth: true
        }
    },
    {
        path: '/questions-bank/directories',
        name: 'questions-bank',
        component: BankQuestions,
        meta :{
            title: 'بنك الأسئلة',
            requiresAuth: true
        }
    },
    {
        path: '/questions-bank/directories/:id',
        name: 'questions-bank-directory',
        component: BankQuestions,
        props: true,
        meta :{
            title: 'بنك الأسئلة',
            requiresAuth: true
        }
    },

    {
        path: '/login',
        name: 'login',
        component: () => import("../views/Login.vue"),
        meta :{
            title: 'تسجيل الدخول',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import("../views/Register.vue"),
        meta :{
            title: 'إنشاء حساب جديد',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import( '../views/ResetPassword.vue'),
        meta :{
        title: 'استعادة كلمة المرور',
        requiresAuth: false,
        requiresGuest: true,
        }
    },
    {
        path: "/terms-and-conditions",
        name: "terms",
        component: () => import( '../views/Terms.vue'),
        meta: {
            title: 'شروط الاستخدام',
            footer: {
                show: true,
                notFixed: true,
            },
        }
    },
    {
        path: "/terms",
        redirect: { name: "terms" },
    },
    {
    path: '/confirm',
    name: 'confirm',
    component: () => import( '../views/Confirm.vue'),
    meta :{
        title: 'تأكيد البريد الإلكتروني',
        requiresAuth: true,
    }
    },
    {
        path: "/links",
        name: "links",
        component: () => import("../views/Links.vue"),
        meta: {
            footer: {
                show: true,
                notFixed: true,
            },
            title: 'روابطنا'
        }
    },
    {
        path: "/about",
        name: "about",
        component: () => import("../views/About.vue"),
        meta: {
            footer: {
                show: true,
                notFixed: true,
            },
            title: 'عن المنصة'
        }
    },
    {
        path: "/(privacy-policy|privacy)",
        name: "privacy-policy",
        component: () => import("../views/Privacy.vue"),
        meta: {
            footer: {
                show: true,
                notFixed: true,
            },
            title: 'سياسة الخصوصية',
        }
    },
    {
        path: "/help",
        name: "help",
        component: Support,
        meta: {
            title: 'الدعم الفني',
            footer: {
                show: true,
                notFixed: true,
            },
            whiteBackground: true,
        }
    },
    {
        path: '/center/registration/:form_id',
        name: 'center-registration',
        component: () => import('../views/CenterRegistration.vue'),
        props: true,
        meta: {
            title: 'تسجيل السنتر',
            requiresAuth: true,
            backButton: true,
            whiteBackground: true,
        }
    },
    {
        path: '*',
        name: 'not-found',
        meta: {
            title: 'الصفحة غير موجودة',
            footer: {
                show: true,
            },
            backIcon: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue')
    }
  ];


  export default routes;